import { Injectable } from '@angular/core';
import { VirsekerBasePageComponent } from 'templates/pages/base-page/virseker-base-page.component';
import { VirsekerDynamicPageComponent } from 'templates/pages/dynamic-page/virseker-dynamic-page.component';
import { FeatureFlag } from 'dataModels/feature-flag';
import { QuoteAppInitService } from 'services/quote-app-init.service';

/**
 * Virseker App Init overrides
 */
@Injectable({
    providedIn: 'root',
})
export class VirsekerAppInitService extends QuoteAppInitService {
    /**
     * This enables us to use the base route setup in squidex to configure the base-route of the application
     * @param baseRoutes
     * @param featureFlags
     * @private
     */
    public override setupRoutes(baseRoutes: Array<string>, featureFlags: FeatureFlag) {
        this.setupRoutesBase(
            featureFlags,
            baseRoutes,
            VirsekerBasePageComponent,
            VirsekerDynamicPageComponent,
        );
    }
}
